import {useCallback, useState} from 'react';

import {useLatest} from './use-latest';

export const usePanel = <PanelType extends string>(defaultPanelId?: PanelType) => {
    const [panelVisible, setPanelVisible] = useState<boolean>(false);
    const [activePanel, setActivePanel] = useState<PanelType | undefined>(defaultPanelId);
    const latestPanel = useLatest(activePanel);

    const switchPanel = useCallback(
        (id: PanelType, handler?: (visible: boolean) => void) => {
            setPanelVisible((prev) => {
                if (!prev || latestPanel.current !== id) {
                    handler && handler(true);
                    return true;
                }
                handler && handler(false);

                return false;
            });
            setActivePanel(id);
        },
        [latestPanel],
    );

    const showPanel = useCallback((id?: PanelType) => {
        if (id) {
            setActivePanel(id);
        }
        setPanelVisible(true);
    }, []);
    const hidePanel = useCallback(() => setPanelVisible(false), []);

    return {
        panelVisible,
        showPanel,
        hidePanel,
        activePanel,
        switchPanel,
    };
};
